<template>

  <div class="row hero" :class="layout">

    <div class="text col-12 col-sm-10 col-md-8 col-xl-6 d-flex flex-column justify-content-center">
      <h1 class="text-white m-0" v-html="title" />
      <SearchJob v-if="search" class="mt-4" />
    </div>

    <div class="media-content">
      <img :src="require(`@/assets/images/${image}`)" v-if="image" class="rounded shadow-lg">

      <video autoplay loop="" playsinline="" muted="" class="bg-dark" v-if="video">
        <source :src="require(`@/assets/videos/${video}`)">
      </video>
    </div>
  </div>

</template>

<script>
  import SearchJob from '@/components/jobs/SearchJob.vue'

  export default {
    name: 'Hero',

    props: {
      title: String,
      video: String,
      search: Boolean,
      image: String,
      layout: String
    },

    components: {
      SearchJob
    }
  }
</script>

<style lang="scss">
  .hero{
    width: auto;
    height: 550px;
    min-height: 400px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 1;

    &:after{
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: -1;
      /* background-color: rgba(35, 31, 31, 0.5); */
      /* background-image: url('~@/assets/images/hero-shape.png'); */
    }

    &.md{
      min-height: auto;
      overflow: unset;

      & > .media-content{
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }

    & > .text{
      z-index: 1;
      .input-group{
        border-radius: 30px;
        overflow: hidden;
        .form-control, .btn{
          height: calc(4rem + 2px);
          display: flex;

          span{
            font-size: 36px;
            svg {
              color: #57FFFF;
            }
          }


          &::placeholder{
            opacity: .5;
          }
        }
      }

      h1{
        font-size: 3.5rem;
        font-weight: 300;
        text-align: left;

        span{
          font-weight: 700;
          color: #57FFFF;
        }

        @include media-breakpoint-down(md){
          font-size: 2rem;
        }
      }
    }

    & > .media-content,
    & > .media-content > img,
    & > .media-content > video{
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: middle;
      z-index: -1;
      overflow: hidden;
    }

    *::-webkit-media-controls-panel {
      display: none !important;
      -webkit-appearance: none;
    }

    *::--webkit-media-controls-play-button {
      display: none !important;
      -webkit-appearance: none;
    }

    *::-webkit-media-controls-start-playback-button {
      display: none !important;
      -webkit-appearance: none;
    }
  }
</style>